Vue.component('popup', {

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            popupVisible: false,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        //
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        togglePopup() {
            TweenMax.set(['.modules-container'], { clearProps: 'all' });
            this.popupVisible = !this.popupVisible;
        },
    },
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/popup.js